import { render, staticRenderFns } from "./student-invoice-en.vue?vue&type=template&id=04be7935&scoped=true&"
import script from "./student-invoice-en.vue?vue&type=script&lang=js&"
export * from "./student-invoice-en.vue?vue&type=script&lang=js&"
import style0 from "./student-invoice-en.vue?vue&type=style&index=0&id=04be7935&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be7935",
  null
  
)

export default component.exports